<script setup lang="ts">
import { UITextMdMedium } from '@gohighlevel/ghl-ui'
import { i18nLocale, useVueI18n } from '../../../locales'
import { PlusIcon } from '@gohighlevel/ghl-icons/24/outline'
import { UITag } from '@gohighlevel/ghl-ui'
import { formatDateWithLocale } from '../../../utils'

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
const t = useVueI18n()
</script>

<template>
  <div class="flex items-center justify-between">
    <UITextMdMedium class="text-base font-semibold">
      <span v-if="data?.metaData?.name" class="text-gray-800">
        {{ data.metaData.name }}
        <template v-if="data?.metaData?.email"
          >({{ data.metaData.email }})</template
        >
      </span>
      <span class="text-gray-800" v-else>{{ data.metaData.email }}</span>
      <span class="text-gray-500 ml-1">
        {{ t('proposalsList.eventLogs.createTitle') }}
      </span>
      <span v-if="data?.metaData?.createdSource" class="text-gray-500 ml-1">
        <template v-if="data.metaData.createdSource === 'workflow'">
          {{ t('proposalsList.eventLogs.fromWorkflow') }}
        </template>
        <template v-else-if="data.metaData.createdSource === 'template'">
          {{ t('proposalsList.eventLogs.fromTemplate') }}
        </template>
        <template v-else-if="data.metaData.createdSource === 'docForm'">
          {{ t('proposalsList.eventLogs.fromDocForm') }}
        </template>
      </span>
    </UITextMdMedium>
  </div>
  <div class="flex justify-between items-end mt-3">
    <p class="text-sm text-gray-500">
      {{
        formatDateWithLocale(
          data.createdAt,
          i18nLocale,
          'MMMM DD, YYYY'
        )
      }}
    </p>
    <UITag type="info" size="medium" class="text-[8px] created-event">
      <template #icon> <PlusIcon class="w-4 h-4 plus-icon" /></template>
      {{ t('proposalsList.eventLogs.created') }}
    </UITag>
  </div>
</template>

<style scoped lang="scss">
.created-event {
  --n-text-color: #004eeb !important;
  --n-color: #eff4ff !important;
  --n-border: 0px !important;
}
.plus-icon {
  color: #2970ff !important;
}
</style>
